// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Rzsi","left":"InfoRow_left__zKbjz"};